/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNumberPad = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h20v14h-6v6H8v-6H2zm8 14v4h4v-4zm4-2v-4h-4v4zm2 0h4v-4h-4zm0-6h4V4h-4zm-2-4h-4v4h4zM8 8V4H4v4zm-4 2v4h4v-4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgNumberPad as NumberPad };
